export const getDestinatonApps = (apps = [], orgin)=>{
    const tempArr = [];
    switch (orgin) {
        case "SFDC":
            tempArr.push(...apps.filter(value => value.code === "XERO" || value.code === "QCKB"));
            break;
        case "QCKB":      
        case "WC":
        case "XERO":
            tempArr.push(...apps.filter(value => value.code === "SFDC"));
            break;
        case "SFTP":
            tempArr.push(...apps.filter(value => value.code === "XERO"));
            break;          
        default:
            tempArr.push(...apps);
            break;
    }
    return tempArr;
}